<template>
  <div>
    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="toDetail(scope.data, scope.$index)"
        >明细</el-button>
      </template>
    </TablePublic>

  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import TablePublic from '@/components/tablePublic'

import { getPurchasePlanList } from '@/api/manage/purchase-plan'
import { getDrySkinReceiptList } from '@/api/manage/report'
import { getProcessFactorySelectList } from '@/api/manage/process-factory'
export default {
  components: {
    TablePublic,
    SearchComponent,
  },
  data() {
    const _this = this
    return {
      dialogVisible: false,
      title: '',
      currentView: '',
      authIdentity: 'process:drySkinReceipt',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'purchasePlanName',
          label: '计划名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'customer',
          label: '客户名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'totalSettlementNetWeight',
          label: '结算鲜果总净重（斤）',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'totalNetWeight',
          label: '干皮总净重（斤）',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'fullRatedWeight',
          label: '满框定重（斤）',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'fullBasketCount',
          label: '满框框数',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'tailWeight',
          label: '尾框重量（斤）',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'totalQuantity',
          label: '总框数',
          isTrue: true,
          align: 'left',
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],

      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'purchasePlanId',
          placeholder: '请选择计划名称',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'customer',
          placeholder: '请选择客户名称',
          value: 'name',
          label: 'name',
          list: [],
          type: 'select',
        },
      ],
    }
  },
  mounted() {
    this.getProcessFactorySelectList()
    this.getPlantationList()
    this.getList()
  },
  methods: {
    getProcessFactorySelectList() {
      getProcessFactorySelectList({
        // ...this.queryParams
        type: 1,
      })
        .then((res) => {
          if (res.flag) {
            this.selectOrInputList[1].list = res.data
          } 
        })
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getDrySkinReceiptList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getPlantationList() {
      getPurchasePlanList().then((res) => {
        this.selectOrInputList[0].list = res.data
      })
    },
    summaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 8) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 9) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 10) {
          const freshPeelTotalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0)

          const totalSettlementNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)

          sums[index] = !totalSettlementNetWeight
            ? totalSettlementNetWeight
            : this.myFixed((freshPeelTotalNetWeight / totalSettlementNetWeight) * 100, 2)
          return
        }
        if (index == 11) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 12) {
          const totalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)

          const totalSettlementNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)

          sums[index] = !totalSettlementNetWeight
            ? totalSettlementNetWeight
            : this.myFixed((totalNetWeight / totalSettlementNetWeight) * 100, 2)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    toDetail({ id, purchasePlanName }) {
      this.$router.push(`/drySkinReceiptDetail?purchasePlanId=${id}&purchasePlanName=${purchasePlanName}`)
    },
    submitFrom() {},
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'myform'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
// @import '../../../../assets/form.less';
@import '~@/assets/tableList.less';
/deep/ .el-button--text {
  font-size: 14px;
}
</style>
